import { render, staticRenderFns } from "./CatBanner.vue?vue&type=template&id=f1314e06&"
import script from "./CatBanner.vue?vue&type=script&lang=js&"
export * from "./CatBanner.vue?vue&type=script&lang=js&"
import style0 from "./CatBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports